import { MetaAdsConnectionSchema } from "@redotech/redo-integrations-definitions-common/integration/meta-ads/meta-ads-definition";
import * as z from "zod";

export const getMetaAdsIntegration = {
  name: "getMetaAdsIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    accountId: z.string().optional(),
    connections: z.array(MetaAdsConnectionSchema),
  }),
};
